import SendRoundedIcon from "@mui/icons-material/SendRounded";
import { Card, CardContent, Divider, InputBase, Paper } from "@mui/material";
import { t } from "i18next";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import CustomBotIcon from "../../../app/assets/custom-icons/CustomBotIcon";
import CoreButtonIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonIcon";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import { hexToRgba } from "../../../utils/functions/hexToRgba";
import {
  useCreateChatbotMutation,
  useGetBotIdQuery,
} from "../../api/admin/chatbotApi";

const ChatBot = ({ idBot }) => {
  const [text, setText] = useState("");
  const [chatHistory, setChatHistory] = useState([]);
  const [bot, setBot] = useState();
  const messagesEndRef = useRef(null);
  const messagesContainerRef = useRef(null);

  const { data: dataBot } = useGetBotIdQuery(idBot, { skip: !idBot });
  const [doSendingChatbot, { isLoading: isLoadingChat }] =
    useCreateChatbotMutation();

  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const rgbaColor = hexToRgba(colorPrimary, 0.3);

  useEffect(() => {
    // Scrolla verso il basso quando i messaggi cambiano
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop =
        messagesContainerRef.current.scrollHeight; // Scroll immediato
    }
  }, [chatHistory]);

  useEffect(() => {
    if (dataBot && dataBot.Data) {
      setBot(dataBot.Data);
    }
  }, [dataBot]);

  const handleChangeText = (e) => {
    setText(e.target.value);
  };

  const handleSendMessage = () => {
    if (text === "") return;
    const userMessage = {
      role: "user",
      content: text,
      timestamp: null,
    };
    const updatedHistoryUser = [...chatHistory, userMessage];

    const bodyData = {
      history: updatedHistoryUser,
      systemPrompt:
        "Tu sei un esperto in materia fiscale e mi devi rispondere solo su domande in ambito fiscale",
      newMessage: text,
    };

    if (bot) {
      bodyData.newMessage = text;
      bodyData.systemPrompt = bot.aiPrompt.content;
    }

    doSendingChatbot(bodyData).then((res) => {
      const assistantMessage = {
        role: "assistant",
        content: `${res?.data?.message?.content}`,
        timestamp: null,
      };

      const updatedHistoryWithAssistant = [
        ...updatedHistoryUser,
        assistantMessage,
      ];
      setChatHistory(updatedHistoryWithAssistant);
      setText("");
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  return (
    <div className="h-full ">
      <div
        style={{ height: "85%" }}
        className="overflow-auto py-8"
        ref={messagesContainerRef}
      >
        <div className="flex justify-center items-center space-x-4 ">
          <div className="w-3/12 flex justify-center">
            <CustomBotIcon className="w-44 h-44" shadows={false} />
          </div>
          <div className="w-9/12 p-8 ">
            <p className="text-lg">
              <span className="font-bold" style={{ color: colorPrimary }}>
                {t("Intro1")}
              </span>{" "}
              {bot ? t("IntroCustom") + " " + bot?.name : t("Intro2")}
            </p>
            <p className="font-bold" style={{ color: colorPrimary }}>
              {t("WriteAMessageToBegin")}
            </p>
          </div>
        </div>
        <Divider />
        <div className="p-6 flex flex-col space-y-6">
          {chatHistory.map((message, index) => (
            <Card
              key={index}
              style={{
                borderRadius: "20px",
                backgroundColor: message?.role === "user" ? "white" : rgbaColor,
                maxWidth: "750px",
              }}
              className={` ${
                message?.role === "assistant" ? "self-start" : "self-end"
              }`}
              elevation={4}
            >
              <CardContent>
                <p className="text-black normal-case m-0 break-all">
                  {message.content}
                </p>
              </CardContent>
            </Card>
          ))}
          {isLoadingChat && (
            <Card
              style={{
                borderRadius: "20px",
                backgroundColor: "white",
                maxWidth: "750px",
              }}
              className={"self-end"}
              elevation={4}
            >
              <CardContent>
                <p className="text-black normal-case m-0 break-all">{text}</p>
              </CardContent>
            </Card>
          )}
          {isLoadingChat && <CoreSpinner />}
        </div>
        <div ref={messagesEndRef} />
      </div>
      <Divider />

      <div
        className="flex justify-center items-center"
        style={{ height: "15%" }}
      >
        <Paper
          component="form"
          sx={{
            p: "2px 4px",
            display: "flex",
            alignItems: "center",
            width: "90%",
            borderRadius: "16px",
            border: "solid 1px lightgrey",
          }}
          elevation={0}
        >
          <InputBase
            multiline
            maxRows={4}
            disabled={isLoadingChat}
            sx={{ ml: 1, flex: 1 }}
            placeholder={t("WriteAMessage")}
            value={isLoadingChat ? "" : text}
            onChange={handleChangeText}
            onKeyDown={handleKeyDown}
          />
          <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
          <CoreButtonIcon
            disabled={isLoadingChat || !text}
            icon={<SendRoundedIcon />}
            onClick={handleSendMessage}
          />
        </Paper>
      </div>
    </div>
  );
};

export default ChatBot;
